import React from 'react'
import Button from './button'
import useCurrentUser from '../../../hooks/use-current-user'
import useCourseEnrollability from '../../user/hooks/use-user-course-enrollability'
import { useCourseEnroller } from '../../../features/same-day-signup-warning';

const EnrollButton = ({
    experience = {},
    onEnrolled = () => {}
}) => {
    //const { enroll, isLoading: isEnrolling, confirmSameDayEnrollment } = useCourseEnroll({ courseId: experience.id, onSuccess: onEnrolled })
    const {enroll, isLoading: isEnrolling } = useCourseEnroller({ course: experience, onSuccess: onEnrolled })
    const { isStudent } = useCurrentUser()
    const { enrollable } = useCourseEnrollability({ courseId: experience.id })
    
    if (!isStudent || !enrollable) {
        return null
    }

    const label = experience.isMaxCapacity ? 'EXPERIENCE IS FULL' : 'ADD THIS EXPERIENCE'

    return (
        <Button
            disabled={isEnrolling || experience.isMaxCapacity}
            onClick = {() => enroll()}
        >
            { isEnrolling ? 'Adding...' : label}
        </Button>
    )
}

export default EnrollButton